<template>
	<div class="quota flex-grow flex-between">
		<template v-for="(group, i) in total">
			<template v-if="i == 1">
				<div v-for="(item, j) in group" :key="j" class="total flex-grow flex">
					<div class="bg flex-grow"></div>
					<div class="content flex-column flex-center">
						<div :style="{'color': color[item.code]}">{{item.data}}</div>
						<p>{{item.name}}</p>
					</div>
				</div>
			</template>
			<ul v-else class="flex-grow flex-column">
				<li v-for="(item, j) in group" :key="j" class="flex-column flex-center flex-grow">
					<div :style="{'color': color[item.code]}">{{item.data}}</div>
					<p>{{item.name}}</p>
				</li>
			</ul>
		</template>
	</div>
</template>

<script>
	import module from '../components/module.vue'

	export default {
		components: {
			module
		},

		props: {
			period: Object
		},

		data() {
			return {
				total: [],
				color: {
					fine_count: '#07F3A4',
					defects_count: '#FF2A2A',
					overdue_work_count: '#FF2A2A',
					overdue_task_count: '#FF2A2A'
				}
			}
		},

		mounted() {
			this.request({
				url: '/digital/summary/data',
				data: this.period,
				success: data => {
					let list = data.data.map(item => item);
					this.total.push(list.splice(0, 2));
					this.total.unshift(list.splice(0, 4));
					this.total.push(list.splice(0, 4));
				}
			})
		}
	}
</script>

<style lang="stylus" scoped>
	.quota {
		position: relative;

		&:before {
			content: '';
			position: absolute;
			top: 1.05rem;
			left: 20%;
			right: 20%;
			bottom: 0;
			background-image: url('~@/assets/image/digital/quota.png');
			background-size: 100% auto;
			background-repeat: no-repeat;
			background-position: center center;
		}

		ul {
			position: relative;
			border: 1px solid rgba(49,198,253,.9);
			background: rgba(49,198,253,.1);
			box-shadow: inset 0 0 .4rem 0 rgba(49,198,253,.3);

			&:nth-child(1) {
				border-radius: .12rem 0 0 .12rem;
			}

			&:nth-last-child(1) {
				border-radius: 0 .12rem .12rem 0;
			}

			&:nth-child(n+2) {
				margin-left: .16rem;
			}

			li {
				position: relative;
				margin: 0 .1rem;

				&:nth-child(n+2):before {
					content: '';
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					height: 1px;
					background: linear-gradient(90deg, rgba(0,255,255,.01), #00FFFF, rgba(0,255,255,.01));
				}

				div {
					font-size: .22rem;
					font-weight: 500;
					color: #fff;
				}

				p {
					margin-top: .12rem;
					font-size: .14rem;
					color: #5DD2FF;
				}
			}
		}

		.total {
			box-sizing: border-box;
			position: relative;
			height: 1.05rem;

			&:nth-child(n+2) {
				margin-left: .16rem;
			}
			
			&:before,
			&:after {
				content: '';
				width: .475rem;
				height: 100%;
				background-image: url('~@/assets/image/digital/total_bg_left.png');
				background-size: calc(100% + 1px) 100%;
			}
			
			&:before {
				background-image: url('~@/assets/image/digital/total_bg_left.png');
			}
			
			&:after {
				background-image: url('~@/assets/image/digital/total_bg_right.png');
				background-position: right top;
			}
			
			.bg {
				height: 100%;
				background-image: url('~@/assets/image/digital/total_bg.png');
				background-size: auto 100%;
			}
			
			.content {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				padding-top: .1rem;

				div {
					font-size: .24rem;
					font-weight: 500;
					color: #fff;
				}

				p {
					margin-top: .12rem;
					font-size: .14rem;
					color: #5DD2FF;
				}
			}
		}
	}
</style>
